import { useT } from '../i18n'
import {
  GRATICULE_DENSITIES,
  densityHintKey,
  densityLabelKey,
  maxLinesFor,
  setGraticuleDensity,
  useGraticuleDensity,
} from '../map/graticuleDensity'
import {
  HIGHLIGHT_HINT_KEY,
  HIGHLIGHT_LABEL_KEY,
  setHsiHighlight,
  useHsiHighlight,
} from '../map/driftHighlight'

/**
 * Настройки вида карты: густота координатной сетки и подсветка траектории.
 *
 * Просьба капитанов: по сетке снимают координату с экрана, и восьми делений на
 * кадр для этого мало. Выбор задаёт ПОТОЛОК числа линий, поэтому переживает зум
 * — на обзоре и на подходе к точке делений одинаково много, меняется лишь их
 * цена в градусах (graticuleDensity.ts). Хранится в этом браузере, как тема.
 */
export function MapSettings() {
  const t = useT()
  const density = useGraticuleDensity()
  const highlight = useHsiHighlight()

  return (
    <div className="max-w-md space-y-4">
      <div>
        <label className="eyebrow mb-2">{t('settings.map.graticuleDensity')}</label>
        <div
          role="radiogroup"
          aria-label={t('settings.map.graticuleDensity')}
          className="flex gap-1 rounded-md border border-hull bg-abyss/60 p-0.5"
        >
          {GRATICULE_DENSITIES.map(d => (
            <button
              key={d.id}
              type="button"
              role="radio"
              aria-checked={density === d.id}
              onClick={() => setGraticuleDensity(d.id)}
              className={
                'flex-1 rounded px-2 py-1.5 text-[11px] font-medium transition-colors ' +
                (density === d.id ? 'bg-sonar text-abyss' : 'text-mist hover:text-foam')
              }
            >
              {t(densityLabelKey(d.id))}
            </button>
          ))}
        </div>
        <p className="mt-2 text-xs text-mist">
          {t('settings.map.graticuleHint', {
            hint: t(densityHintKey(density)),
            max: maxLinesFor(density),
          })}
        </p>
      </div>
      <p className="text-xs text-mist">
        {t('settings.map.graticuleAbout')}
      </p>
      {/* Подсветка усика «Траекторий по HSI» при наведении. Тумблер — тот же,
          что у наложений карты: одна и та же вещь не должна выглядеть в
          кабинете двумя разными органами управления. */}
      <div className="border-t border-hull pt-4">
        <button
          type="button"
          role="switch"
          aria-checked={highlight}
          onClick={() => setHsiHighlight(!highlight)}
          className="flex w-full items-center gap-3 rounded-lg px-1 py-2 text-left text-sm text-foam transition-colors hover:bg-haze"
        >
          <span
            aria-hidden
            className={[
              'relative h-[19px] w-[34px] flex-shrink-0 rounded-full transition-colors',
              highlight ? 'bg-sonar-dim' : 'bg-hull',
            ].join(' ')}
          >
            <span
              className={[
                'absolute top-0.5 h-[15px] w-[15px] rounded-full transition-all',
                highlight ? 'left-[17px] bg-deep' : 'left-0.5 bg-mist',
              ].join(' ')}
            />
          </span>
          <span className="flex-1">{t(HIGHLIGHT_LABEL_KEY)}</span>
        </button>
        <p className="mt-1 px-1 text-xs text-mist">{t(HIGHLIGHT_HINT_KEY)}</p>
      </div>
    </div>
  )
}
